module.exports = __webpack_public_path__ + "static/img/104162.79b4d26f.png";